import request from './request'


export default {
    async login(username, password) {
        return await request.post("users/login", {
            Username: username,
            Password: password
        }, true)

    },
    async addUser(userData) {
        return await request.post("users", userData, false)
    },
    async updateUser(userData) {
        return await request.put("users", userData, false)
    },
    async updateUserStatus(userStatus) {
        return await request.post("users/status", userStatus, false)
    },
    async updatePassword(userPassword) {
        return await request.post("users/password", userPassword, false)
    },
    async getUser(id) {
        return await request.get("users/" + id, {}, false)
    },
    async getUserTypes() {
        return await request.get("user-type", false)
    }
}